import { render, staticRenderFns } from "./QuoteTransactions.vue?vue&type=template&id=05c34a34"
import script from "./QuoteTransactions.vue?vue&type=script&lang=js"
export * from "./QuoteTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports